import { cn } from 'modules/v2/common/utils/cn';

import strings from '../../strings';
import { ORDER_STATUS } from '../../constants';

const STAGES = [
  { id: 'submitted', label: strings.detail.stepSubmitted },
  { id: 'paid', label: strings.detail.stepPaid },
  { id: 'accepted', label: strings.detail.stepAccepted },
  { id: 'in_production', label: strings.detail.stepInProduction },
  { id: 'shipped', label: strings.detail.stepShipped },
];

const STATUS_STAGE_INDEX = {
  [ORDER_STATUS.DRAFT]: 0,
  [ORDER_STATUS.RESOLVING]: 0,
  [ORDER_STATUS.REVIEW]: 0,
  [ORDER_STATUS.PAID]: 1,
  [ORDER_STATUS.ACCEPTED]: 2,
  [ORDER_STATUS.IN_PRODUCTION]: 3,
  [ORDER_STATUS.SHIPPED]: 4,
};

/**
 * Member-facing progress stepper for an order.
 * Cancelled / resolution_failed orders are rendered as banners by the parent
 * instead of this stepper.
 */
const OrderStatusStepper = ({ status }) => {
  const currentIndex = STATUS_STAGE_INDEX[status] ?? 0;

  return (
    <ol className="flex flex-wrap items-center gap-3" data-testid="mod-order-status-stepper">
      {STAGES.map((stage, index) => {
        const isReached = index <= currentIndex;

        return (
          <li key={stage.id} className="flex items-center gap-2">
            <span
              className={cn(
                'h-3 w-3 rounded-full',
                isReached ? 'bg-primary-500' : 'bg-neutral-200',
              )}
            />
            <span
              className={cn(
                'text-sm',
                index === currentIndex ? 'font-semibold text-neutral-800' : 'text-neutral-500',
              )}
            >
              {stage.label}
            </span>
            {index < STAGES.length - 1 && <span className="text-neutral-300">→</span>}
          </li>
        );
      })}
    </ol>
  );
};

export default OrderStatusStepper;
